import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../../core/services/api.service';
import { IOrganizationConfig } from '../../../../types/IOrganizationConfig';
import { IOrganizationConfigUpdatePayload } from '../../../../types/IOrganizationConfigUpdatePayload';

@Injectable({ providedIn: 'root' })
export class OrganizationService {
  private readonly api = inject(ApiService);

  getConfig(): Observable<IOrganizationConfig> {
    return this.api.get<IOrganizationConfig>('/api/Organization');
  }

  /**
   * The endpoint replaces the whole configuration, so this takes the full payload rather than the
   * fields being changed — that way a caller cannot blank an unrelated setting by omitting it.
   */
  updateConfig(payload: IOrganizationConfigUpdatePayload): Observable<IOrganizationConfig> {
    return this.api.put<IOrganizationConfig>('/api/Organization', payload);
  }

  uploadLogo(file: File): Observable<IOrganizationConfig> {
    const formData = new FormData();
    formData.append('file', file);
    return this.api.postForm<IOrganizationConfig>('/api/Organization/logo', formData);
  }

  getLogoBlob(): Observable<Blob> {
    return this.api.getBlob('/api/Organization/logo');
  }
}
